import { ProfileModel } from "@modules/main/components/profile/new-profile/entities/profile-model";

export function getName(profile: ProfileModel): string {
	return profile.forename + " " + profile.surname;
}
